<h3>Player Winnings</h3>
<div class="flex-col">
  @if (uiState === uiStateForTemplate.ShowData) {
    <ag-grid-angular
      id="playerWinningsGrid"
      class="ag-theme-quartz margin-top-med large-table"
      data-testid="player-winnings-grid"
      [tooltipShowDelay]="0"
      rowClass="table-row"
      domLayout='autoHeight'
      overlayNoRowsTemplate="<span>This player has never won this game</span>"
      (gridReady)="onPlayerWinningsGridReady($event)"
      [rowData]="winnings"
      [pagination]="true"
      [columnDefs]="playerWinningsColDefs">
    </ag-grid-angular>
  } @else {
    <mat-progress-spinner mode="indeterminate" class="center-margin"></mat-progress-spinner>
  }
</div>

